export type PlatformReportTargetType = 'user' | 'project' | 'comment'

export type PlatformReportReasonCode =
  | 'spam'
  | 'harassment'
  | 'hate'
  | 'illegal'
  | 'other'

export type PlatformReportStatus = 'open' | 'reviewed' | 'dismissed' | 'actioned'

export interface IPlatformReportResource {
  id: number
  target_type: PlatformReportTargetType
  target_id: number
  reason_code: PlatformReportReasonCode
  message: string | null
  status: PlatformReportStatus
  created_at: string
}

export interface IStaffPlatformReportResource extends IPlatformReportResource {
  reporter: {
    id: number | null
    slug: string | null
    shortname?: string | null
    fullname?: string | null
    avatar?: string | null
    deleted?: boolean
  } | null
  staff_note: string | null
  reviewed_at: string | null
  reviewed_by: {
    id: number | null
    slug: string | null
    shortname?: string | null
    fullname?: string | null
  } | null
}

export interface ICreatePlatformReportBody {
  target_type: PlatformReportTargetType
  target_id: number
  reason_code: PlatformReportReasonCode
  message?: string
}

export interface IUpdateStaffPlatformReportBody {
  status: 'reviewed' | 'dismissed' | 'actioned'
  staff_note?: string
}

export const PLATFORM_REPORT_REASON_LABELS: Record<PlatformReportReasonCode, string> = {
  spam: 'Спам',
  harassment: 'Травля / оскорбления',
  hate: 'Ненависть / дискриминация',
  illegal: 'Незаконный контент',
  other: 'Другое',
}
